import { LOCAL_DEV_HOST, LOCAL_DEV_ORIGIN, PRODUCTION_HOST, PRODUCTION_ORIGIN } from '../constants'

function getTargetValue(
  reqHost: string | string[] | undefined,
  localValue: string,
  productionValue: string
): string {
  const isLocal = reqHost && typeof reqHost === 'string' && reqHost.includes(LOCAL_DEV_HOST)
  return isLocal ? localValue : productionValue
}

export function getTargetHost(reqHost: string | string[] | undefined): string {
  return getTargetValue(reqHost, LOCAL_DEV_HOST, PRODUCTION_HOST)
}

export function getTargetOrigin(reqHost: string | string[] | undefined): string {
  return getTargetValue(reqHost, LOCAL_DEV_ORIGIN, PRODUCTION_ORIGIN)
}
